export function toYmd(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function getLastNDaysRange(days = 6) {
  const endDate = new Date();
  endDate.setHours(0, 0, 0, 0);

  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - (days - 1));

  return {
    from: toYmd(startDate),
    to: toYmd(endDate),
    startDate,
    endDate,
  };
}

export function parseYmd(value) {
  if (!value) return null;
  const input = String(value).slice(0, 10);
  const [y, m, d] = input.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function isWithinDateRange(value, startDate, endDate) {
  const date = parseYmd(value);
  if (!date) return false;
  return date >= startDate && date <= endDate;
}

export function filterByLastNDays(items, days = 6, dateField = 'eventDate') {
  const { startDate, endDate } = getLastNDaysRange(days);
  return (items || []).filter((item) => {
    const value =
      item?.[dateField] ||
      item?.submittedAt ||
      item?.eventDate ||
      item?.date;
    return isWithinDateRange(value, startDate, endDate);
  });
}
